import Link from "@/components/link";
import React, { useMemo } from "react";
import Image from "@/components/image";
import styles from "./index.module.css";
import Tooltip from "../tooltip";
import { MemberType } from "@/constants";

interface ListColumnItemProps {
  title: string;
  image?: string;
  type: "news" | "database" | "activity" | "building" | keyof typeof MemberType;
  memberType?: string;

  content?: string;
  id: number;
  labelList?: Label[];
  userActivityStatus?: number;
  miniprogramCode?: string;

  gmtStart?: string;
  gmtEnd?: string;
  activityType?: 1 | 2 | 3 | 4 | 5 | 6;

  friendlyTime?: string;
}

export default function ListColumnItem(props: ListColumnItemProps) {
  const btnText = useMemo(() => {
    switch (props.userActivityStatus) {
      case 1:
        return "预约";
      case 2:
        return "即将开始";
      case 3:
        return "直播中";
      case 4:
        return "往期活动";
      case 5:
        return "评审中";
      case 6:
        return "投票中";
      case 7:
        return "无状态";
      case 8:
        return "报名中";
      case 9:
        return "敬请期待";
      case 10:
        return "活动中";
      case 11:
        return "回放";
      default:
        return "其他";
    }
  }, [props.userActivityStatus]);

  const getTime = useMemo(() => {
    switch (props.activityType) {
      case 1:
      case 3:
      case 4:
      case 5:
      case 6:
        return `${props.gmtStart?.split(" ")[0]} 至 ${props.gmtEnd?.split(" ")[0]}`;
      case 2:
        if (!props.gmtStart) return "未知时间开播";
        const time = props.gmtStart.split(" ");
        return `${time[0]} ${time[1].slice(0, time[1].lastIndexOf(":"))}开播`;
    }
  }, [props.activityType, props.gmtStart, props.gmtEnd]);

  return (
    <Link
      key={props.id}
      className={styles.activity_link}
      href={`/detail/${props.type}/${props.id}`}
      aria-label="跳转详情"
    >
      <article className={styles.activity_item}>
        {props.image && (
          <div className={styles.activity_item__img_wrapper}>
            <Image
              className={styles.activity_item__img}
              src={props.image}
              alt={props.title}
              fill
              style={{ objectFit: 'cover' }}
              placeholder="blur"
              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP89/dfPQAJdAN6CIDaegAAAABJRU5ErkJggg=="
            />
          </div>
        )}
        <section className={styles.activity_item_content}>
          <h3 title={props.title}>{props.title}</h3>
          {props.userActivityStatus ? (
            <div className={styles.acitvity_description}>
              <p title={getTime}>{getTime}</p>
              <Tooltip
                placement="right"
                miniProgramCode={props.miniprogramCode || ""}
                miniProgramTitle={"手机扫码参与活动"}
                miniProgramContent={"扫码参加活动报名"}
              >
                <button
                  className="status_btn"
                  data-btn-status={props.userActivityStatus}
                >
                  {btnText}
                </button>
              </Tooltip>
            </div>
          ) : (
            <p title={props.content || props.friendlyTime}>{props.content || props.friendlyTime}</p>
          )}

          {props.labelList && (
            <ul
              className={styles.label_wrapper}
              aria-label='标签列表'
            >
              {props.labelList?.map((item, index) => (
                <li
                  aria-posinset={index + 1}
                  aria-setsize={props.labelList?.length ?? 0}
                  className={styles.label_item}
                  key={item.id}
                >
                  {item.labelName}
                </li>
              ))}
            </ul>
          )}
        </section>
      </article>
    </Link>
  );
}
